<template>
  <div class="px-5 pb-5" style="height: 100%; overflow: auto">
    <div>
      <v-alert
        v-if="command.status === 'connect'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        class="mt-2"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        class="mt-2"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <div
          v-if="
            ['vf1000', 'vf600'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>SN ของ Device</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.sn || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ชื่อรุ่นของ Device</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.type || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ชื่อเรียกของ Device</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.name || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>วันเวลาของ Device</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.time || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Algorithm Version</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.alg_edition || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Firmware Version</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.edition || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>IP address</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.ip || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Gateway</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.gateway || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Subnet mask</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.netmask || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>MAC address</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.mac || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>managerlock</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.managerlock || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ลงทะเบียน admin ได้สูงสุด</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.max_managernum || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ลงทะเบียน admin ไปแล้ว</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.managernum || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ลงทะเบียนพนักงานได้สูงสุด</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.max_employee || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ลงทะเบียนพนักงานไปแล้ว</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.real_employee || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title
                >บันทึก Transaction ได้สูงสุด</v-list-item-title
              >
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.max_facerecord || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>บันทึก Transaction ไปแล้ว</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.real_facerecord || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>ระดับความดังเสียง</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ command.responseData.volume || '-' }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div
          v-else-if="
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in command.responseData"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else>
          <v-list-item
            two-line
            v-for="(value, key) in command.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
      <div v-if="command.status === 'fail'">
        <div
          v-if="
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in command.responseData"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else>
          <v-list-item
            two-line
            v-for="(value, key) in command.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      syncJobId: null,
    }
  },

  computed: {
    deviceInfoTranslate() {
      return this.$store.state.hardware.deviceInfoTranslate
    },
  },

  async mounted() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        hardware_model: this.hardware.hardware_model.hardware_model_code,
        body: {
          hardware_uuid: this.hardware.hardware_uuid,
          data: null,
        },
      }

      const [_, deviceInfoData] = await Promise.all([
        this.fetchDeviceInfoTranslate(),
        this.getDeviceInfo(payload),
      ])

      this.command = {
        status: 'connect',
        date: deviceInfoData.create_datetime,
      }
      this.syncJob(deviceInfoData.sync_job_uuid)
    } catch (error) {
      if (error.response && error.response.data) {
        this.command = {
          status: 'fail',
          date: new Date(),
          responseData: {
            Type: 'Get Device Info Fail',
            Message: error.response.data.message || 'Error',
          },
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getDeviceInfo: 'hardware/getDeviceInfo',
      fetchJob: 'hardware/fetchJob',
      fetchDeviceInfoTranslate: 'hardware/fetchDeviceInfoTranslate',
      userAcknowledge: 'hardware/userAcknowledge',
    }),

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        if (
          res.command === 'get_device_info' &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.deviceInfoTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) => {
                return {
                  key: subItem.key,
                  key_name:
                    this.deviceInfoTranslate?.keys[subItem.key]?.th ||
                    subItem.key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: subItem.value,
                  type: subItem.type,
                }
              }),
            }
          })

          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        } else {
          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: res.response_json,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        }
      } else if (res.done_datetime && !res.is_response_success) {
        if (
          ['get_device_info'].includes(res.command) &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeInfoTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) => {
                return {
                  key: subItem.key,
                  key_name:
                    this.employeeInfoTranslate?.keys[subItem.key]?.th ||
                    subItem.key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: subItem.value.toString().trim(), // fix int and space
                  type: subItem.type,
                }
              }),
            }
          })

          this.command = {
            status: 'fail',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
          return
        }

        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
